import React, { useState } from "react";
import styles from "./CreateInvoice.module.css";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import { IoReceiptOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import { FaUserPlus } from "react-icons/fa";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import CheckboxAndData from "../../components/CheckboxAndData/CheckboxAndData";
const CreateInvoice = () => {
  const dispatch = useDispatch();
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [search, setSearch] = useState("");
  const dummyStudents = [
    { id: "s1", name: "John" },
    { id: "s2", name: "Steeve" },
    { id: "s3", name: "John" },
    { id: "s4", name: "Steeve" },
    { id: "s5", name: "John" },
    { id: "s6", name: "Steeve" },
    { id: "s7", name: "John" },
    { id: "s8", name: "Steeve" },
    { id: "s9", name: "John" },
    { id: "s10", name: "Steeve" },
  ];

  const [invoiceItems, setInvoiceItems] = useState([
    {
      name: "ITEM 1",
      quantity: 1,
      unitPrice: "INR 120",
      tax: "INR 10",
      amount: "INR 130",
    },
  ]);
  const handleCheckboxChange = (id) => {
    setSelectedStudents((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
  const handleSave = () => {
    console.log("Selected students:", selectedStudents);
    dispatch(closeModal()); // Optional: close modal after save
  };

  const handleClose = () => {
    dispatch(closeModal());
  };
  const filteredStudents = dummyStudents.filter((student) =>
    student.name.toLowerCase().includes(search.toLowerCase())
  );

  const tableHeadings = [
    { title: "Item Name", accessor: "name" },
    { title: "Quantity", accessor: "quantity" },
    { title: "Unit Price", accessor: "unitPrice" },
    { title: "Tax", accessor: "tax" },
    { title: "Amount", accessor: "amount" },
  ];

  return (
    <div className={styles.totaldata}>
      <div className={styles.container}>
        <div className={styles.modal}>
          <div className={styles.header}>
            <HeadingAndIcon
              icon={<IoReceiptOutline />}
              heading="Create Invoice"
              headingClass={styles.primaryHeading}
            />

            <ToClose onClose={handleClose} />
          </div>

          <div className={styles.invoiceInfo}>
            <p>
              <span className={styles.primary}>First Term</span>, Monthly
              Billing
            </p>
            <p>
              <span className={styles.secondline}>Next Invoice Details</span>,
              Your invoice will be generated on 07/12/2025 due on 13/12/2025 for
              the period of 01/11/2025 to 30/11/2025
            </p>
          </div>

          {/* 🧾 Top Table */}

          <div className={styles.seconddivision}>
            <div className={styles.heading}>
              <h4>Invoice Details</h4>
            </div>
            <div className={styles.whiteshadowbox}>
              <div className={styles.tableSection}>
                <DynamicTable
                  headings={tableHeadings}
                  columnData={invoiceItems}
                />

                {/* 📝 Form Below Table */}
                <div className={styles.tablebelow}>
                  <div className={styles.row}>
                    <HeadingAndDropDown
                      label="Discount Code"
                      name="discount"
                      options={[{ label: "Code A", value: "A" }]}
                    />
                    <HeadingAndDropDown
                      label="Tax"
                      name="tax"
                      options={[{ label: "GST 18%", value: "gst18" }]}
                    />
                    <CheckboxAndData
                      // checked={
                      //   selectedStudents.length === filteredStudents.length
                      // }
                      // onChange={(e) =>
                      //   setSelectedStudents(
                      //     e.target.checked
                      //       ? filteredStudents.map((s) => s.id)
                      //       : []
                      //   )
                      // }
                      label={"Refundable"}
                      checkboxSize={14}
                      labelSize={16}
                    />
                  </div>

                  <div className={styles.noteSection}>
                    <label className={styles.noteLabel}>School Notes</label>
                    <textarea
                      className={styles.textarea}
                      placeholder="Enter any description you want"
                    />
                  </div>

                  <div className={styles.noteSection}>
                    <label className={styles.noteLabel}>Parent Notes</label>
                    <textarea
                      className={styles.textarea}
                      placeholder="Enter any description you want"
                    />
                  </div>
                  <div className={styles.bothactions}>
                    <div className={styles.addMore}>Add invoice Item</div>
                    <div className={styles.actions}>
                      <SaveAndCancel onCancel={() => {}} onSave={() => {}} />
                    </div>
                  </div>
                </div>
              </div>

              {/* 🧾 Bottom Summary Table */}
              <div className={styles.summarySection}>
                <DynamicTable
                  headings={tableHeadings}
                  columnData={invoiceItems}
                />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.sectionCard}>
          <div className={styles.sectionHeader}>
            <HeadingAndIcon icon={<FaUserPlus />} heading="Select Student" />
          </div>
          <div className={styles.studentdata}>
            <div className={styles.controls}>
              <SearchBar
                placeholder="Search Student"
                onChange={(e) => setSearch(e.target.value)}
              />
              <Dropdown
                bgColor="var(--Utility_Color9)"
                label="Room"
                options={["Room A", "Room B"]}
              />
            </div>

            <div className={styles.listHeader}>
              <CheckboxAndData
                checked={selectedStudents.length === filteredStudents.length}
                onChange={(e) =>
                  setSelectedStudents(
                    e.target.checked ? filteredStudents.map((s) => s.id) : []
                  )
                }
                label={"Select All"}
                checkboxSize={14}
                labelSize={16}
              />
            </div>

            <div className={styles.grid}>
              {filteredStudents.map((student) => (
                <CheckboxAndData
                  key={student.id}
                  checked={selectedStudents.includes(student.id)}
                  onChange={() => handleCheckboxChange(student.id)}
                  label={student.name}
                  checkboxSize={14}
                  labelSize={16}
                />
              ))}
            </div>

            <div className={styles.footerActions}>
              <SaveAndCancel onSave={handleSave} onCancel={handleClose} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateInvoice;
